module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-main smui"
  }, [_c('full-page', [_c('section', {
    staticClass: "page-header fp-section"
  }, [_c('h1', {
    staticClass: "project-name"
  }, [_vm._v("smui")]), _vm._v(" "), _c('h2', {
    staticClass: "project-tagline"
  }, [_vm._v("smui 一套适用于PC管理系统的Vue组件库")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "http://gitlab.alibaba-inc.com/front_web/smui-dev.git"
    }
  }, [_vm._v("源码")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "./home/index.html"
    }
  }, [_vm._v("组件库")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "./platform/index.html"
    }
  }, [_vm._v("实例")]), _vm._v(" "), _c('rotage-box')]), _vm._v(" "), _c('section', {
    staticClass: "fp-section sky-1"
  }, [_c('ul', {
    staticClass: "flex"
  }, [_c('li', {
    staticClass: "logo-item"
  }, [_c('div', {
    staticClass: "logo vue-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('a', {
    attrs: {
      "href": "http://cn.vuejs.org/",
      "target": "_blank"
    }
  }, [_vm._v("Vue")])])]), _vm._v(" "), _c('li', {
    staticClass: "logo-item"
  }, [_c('div', {
    staticClass: "logo webpack-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('a', {
    attrs: {
      "href": "/home/"
    }
  }, [_vm._v("Components")])])]), _vm._v(" "), _c('li', {
    staticClass: "logo-item"
  }, [_c('div', {
    staticClass: "logo doc-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('a', {
    attrs: {
      "href": "https://linkwisdom.gitbooks.io/smui/content/"
    }
  }, [_vm._v("Documents")])])])])]), _vm._v(" "), _c('section', {
    staticClass: "fp-section sky-2"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-box info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.terms.Dialog.title))]), _vm._v(" "), _vm._l((_vm.terms.Dialog.desc), function(item) {
    return _c('p', [_vm._v(_vm._s(item))])
  })], true), _vm._v(" "), _c('dialog-panel', {
    staticClass: "flex-box"
  }, [_c('div', {
    slot: "title"
  }, [_vm._v("弹窗标题")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("弹窗内容")])])])]), _vm._v(" "), _c('section', {
    staticClass: "fp-section sky-3 flex"
  }, [_c('div', {
    staticClass: "flex-box info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.terms.DatePicker.title))]), _vm._v(" "), _vm._l((_vm.terms.DatePicker.desc), function(item) {
    return _c('p', [_vm._v(_vm._s(item))])
  })], true), _vm._v(" "), _c('div', {
    staticClass: "flex-box",
    staticStyle: {
      "width": "600px"
    }
  }, [_c('date-picker')])]), _vm._v(" "), _c('section', {
    staticClass: "fp-section comp-list sky-4"
  }, [_c('img', {
    attrs: {
      "src": "http://image.uc.cn/s/uae/g/2p/material/images/components-x1.png",
      "id": "components-list"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "fp-section"
  }, [_c('post-script', {
    attrs: {
      "src": '//jsfiddle.net/linkwisdom/56L5rvyg/embed/'
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "fp-section sky-5"
  }, [_c('doc', {
    staticClass: "flex-box doc"
  })]), _vm._v(" "), _c('section', {
    staticClass: "fp-section page-footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    attrs: {
      "href": "http://cn.vuejs.org/"
    }
  }, [_vm._v("Vue")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://sm-ui.github.io/"
    }
  }, [_vm._v("smui.io")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/sm-ui/"
    }
  }, [_vm._v("github/smui")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/smui"
    }
  }, [_vm._v("npm/smui")])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_vm._v("2017©神马商业搜索前端组")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-63cb2146!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/index/main.vue
// module id = 516
// module chunks = 4